import { ColumnDefinition } from './SortedTableHeader';

// these columns are always shown at the beginning of the row and cannot be hidden or moved
export const HIGHLIGHT_COLUMN_NAMES = ['highlight', 'hasChanges'];
// these columns are always shown at the end of the row and cannot be hidden or moved
export const ACTION_COLUMN_NAMES = ['action', 'actionButton'];

export type TableColumnProperty<TableColumnEnum extends string> = {
    column: TableColumnEnum;
    visible: boolean;
};

export type TableColumnProperties<TableColumnEnum extends string> = TableColumnProperty<TableColumnEnum>[];

export const getDefaultTableColumnSettings = <TableColumnEnum extends string>(
    columnDefinition: ColumnDefinition<TableColumnEnum>[],
): TableColumnProperties<TableColumnEnum> => {
    const ignoredColumns = [...ACTION_COLUMN_NAMES, ...HIGHLIGHT_COLUMN_NAMES];
    return columnDefinition
        .filter((definition) => !ignoredColumns.includes(definition.column))
        .map((definition) => ({
            column: definition.column,
            visible: true,
        }));
};
